import type { Room } from "@circle-react/types/Live/Room";
import { ElapsedTimeIndicator } from "./Indicators/ElapsedTimeIndicator";
import { LiveIndicator } from "./Indicators/LiveIndicator";
import { RecordingIndicator } from "./Indicators/RecordingIndicator";

export const PublicStatusBar = ({ room }: { room: Room }) => {
  const { live_at: liveAt, recording_enabled: isRecording } = room;

  return (
    <>
      {liveAt && <ElapsedTimeIndicator liveAt={liveAt} />}
      {isRecording && <RecordingIndicator />}
      <LiveIndicator />
    </>
  );
};
